export const WorkerJoinDragType = "WorkerJoin";
